import { FC, Fragment, Key, useState } from 'react'
import { useForm } from 'react-hook-form'
import { FileUpload } from './FileUpload'
import Swal from 'sweetalert2'
import tradegridPlusService from './../../../../../Services/tradegridPlusService'
import { handleError } from './../../../../../Helpers'
import { handleLoading, handleSuccess } from './../../../../../Helpers/alert/alerts'
import uploadDocumentService from './../../../../../Services/uploadDocumentService'

import state from './../../../../../Data/stateNG.json'
import customerService from './../../../../../Services/customerService'
import { Logger } from './../../../../../Helpers/Logger'
import { toast, ToastContainer } from 'react-toastify'
import './ExperienceCenter.scss'

export interface ExperienceForm {
  stationName: string
  product: string
  pumps: number
  dailySalesVolume: number
  stationAddress: string
  state: string
  latitude: number | null
  longitude: number | null
  customerMsisdn: string
}

const CreateNewExperienceCenter: FC<{ closeModal: () => void }> = ({ closeModal }) => {
  const [step, setStep] = useState(1)
  const [request, setRequest] = useState<boolean>(false)
  const [succesfully, setSuccesfully] = useState(false)

  const {
    register,
    reset,
    formState: { errors },
    getValues,
  } = useForm<ExperienceForm>({
    defaultValues: {
      stationName: '',
      product: 'pms_only',
      pumps: 0,
      dailySalesVolume: 0,
      stationAddress: '',
      state: '',
      latitude: 0,
      longitude: 0,
    },
  })

  const [images, setImages] = useState<Array<{ file: File; name: string }>>([])

  const handleFileUpload = async (file: File | null, fileName: string) => {
    const fileIndex = images.findIndex((f) => f.name === fileName)

    if (file) {
      if (fileIndex !== -1) {
        const updatedFiles = [...images]
        updatedFiles[fileIndex] = { name: fileName, file }

        setImages(updatedFiles)
      } else {
        setImages([...images, { file: file, name: fileName }])
      }
    }
  }

  // --- Submit Step 1 ---
  const handleContinue = () => {
    const values = getValues()

    if (values.dailySalesVolume && values.dailySalesVolume < 3500) {
      const loading = handleLoading('Processing please wait...')

      setTimeout(() => {
        toast.dismiss(loading)
        handleError({
          response: {
            data: {
              error: 'Sorry, you are not eligible at this time for the Experience Centre',
            },
          },
        })
        return
      }, 3000)
    }

    // check required
    if (!values.stationName || !values.stationAddress || !values.state) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        text: 'Please complete all required fields',
        showConfirmButton: false,
        timer: 1500,
      })
      return
    }

    setStep(2)
  }

  // --- Final Submit ----
  const submitApplication = async () => {
    setRequest(true)
    const payload = getValues()

    const finalPayload = {
      ...payload,
      //   latitude: location.lat,
      //   longitude: location.lng,
    }
    console.log('FINAL SUBMISSION → ', finalPayload)

    await tradegridPlusService.createExperienceCenter(finalPayload).then(
      (response) => {
        if (images.length === 0) {
          setSuccesfully(true)
          Swal.fire({
            position: 'center',
            icon: 'success',
            text: 'Application Submited Successfully',
            showConfirmButton: false,
            timer: 2000,
          })

          setRequest(false)
          return
        }
        startUpload(response.data.data.id)
      },
      (error: { response?: { data?: { error: string } } }) => {
        setRequest(false)
        handleError(error)
      },
    )
  }

  const startUpload = async (expUuid: string) => {
    const uploadToastId = handleLoading('Uploading your documents...')

    const arraySize = images.length
    for (const [index, currentPlpImage] of images.entries()) {
      const formData = new FormData()

      // console.log({ arraySize, index, formData, expUuid });

      // formData.append("file", currentPlpImage.file);
      formData.append('file', currentPlpImage.file, currentPlpImage.file.name)

      await uploadDocumentService.upload(currentPlpImage.name, expUuid, formData).then(
        (response) => {
          console.log({ uploadedfILE: response })
          if (index === arraySize - 1) {
            setSuccesfully(true)
            Swal.fire({
              position: 'center',
              icon: 'success',
              text: 'Application Submited Successfully',
              showConfirmButton: false,
              timer: 2000,
            })

            setRequest(false)
            toast.dismiss(uploadToastId)
            reset()
            setImages([])
          }
        },
        (error: { response: { data: { error: string } } }) => {
          handleSuccess(
            'Error occured while uploading your documents:  ' + error.response.data.error,
          )
          toast.dismiss(uploadToastId)

          if (index === arraySize - 1) {
            setRequest(false)

            closeModal()
            handleSuccess(
              'Traders Card created successfully but an error occured while uploading your documents:  ' +
                error.response.data.error,
            )
          }
        },
      )
    }
  }

  const [msisdnErrors, setMsisdnErrors] = useState<boolean>()
  const [msisdnDetails, setMsisdnDetails] = useState<{ firstName: string; lastName: string }>()

  const verifyMsisdn = async (e: { target: { value: string } }): Promise<void> => {
    const msisdn: string = e.target.value
    setMsisdnDetails(undefined)
    const endpoint = `customerMsisdn=${encodeURIComponent(msisdn)}`
    if (msisdn.length >= 10 && msisdn.length <= 15) {
      await customerService.searchCustomer(endpoint, 1, 'DESC').then(
        (response) => {
          setMsisdnDetails({
            firstName: response.data.data.dataset[0].firstName,
            lastName: response.data.data.dataset[0].lastName,
          })

          setMsisdnErrors(false)
        },
        (error: { response: { data: { error: string } } }) => {
          setMsisdnErrors(true)
          Logger(error.response)
        },
      )
    }
  }
  return (
    <div className='CreateNewExperienceCenter'>
      <Fragment>
        <div className='application-form'>
          <div className='row'>
            <div className='col-6 step-title'>
              {step === 1 ? 'Station Details' : 'Upload Station Photos'}
            </div>
            <div className='col-6 step-number text-end'>Step {step} of 2</div>
          </div>
          {step === 1 && (
            <Fragment>
              <div className='form-group mb-3'>
                <label htmlFor='msisdn'>Customer msisdn</label>
                <input
                  type='text'
                  id='msisdn'
                  className={errors.customerMsisdn ? 'form-control is-invalid' : 'form-control'}
                  {...register('customerMsisdn', {
                    onChange: (e: { target: { value: string } }) => {
                      verifyMsisdn(e)
                    },
                  })}
                />
                {errors.customerMsisdn && (
                  <div className='error text-danger'>{errors.customerMsisdn.message}</div>
                )}
                {msisdnErrors && (
                  <div className='error text-danger'>Phone number does not exist</div>
                )}
                {msisdnDetails && (
                  <small className='error text-success fw-bolder'>
                    {msisdnDetails.firstName} {msisdnDetails.lastName}
                  </small>
                )}
              </div>

              <div className='form-input mt-4'>
                <label>Retail station name</label>
                <input
                  type='text'
                  className='form-control'
                  {...register('stationName', { required: true })}
                />
                {errors.stationName && <small className='text-danger'>Required</small>}
              </div>

              <div className='form-input mt-3'>
                <label>What product do you sell?</label>
                <select className='form-control' {...register('product')}>
                  <option value='pms_only'>PMS Only</option>
                  <option value='ago_only'>AGO Only</option>
                  <option value='pms_and_ago'>PMS & AGO</option>
                </select>
              </div>

              <div className='form-input mt-3'>
                <label>How many pumps?</label>
                <input
                  type='number'
                  className='form-control'
                  {...register('pumps', { valueAsNumber: true })}
                />
              </div>

              <div className='form-input mt-3'>
                <label>Daily Sales Volume</label>
                <input
                  type='number'
                  className='form-control'
                  {...register('dailySalesVolume', {
                    valueAsNumber: true,
                  })}
                />
              </div>

              <div className='form-input mt-3'>
                <label>Station Address</label>
                <input
                  type='text'
                  className='form-control'
                  {...register('stationAddress', {
                    required: true,
                  })}
                />
                {errors.stationAddress && <small className='text-danger'>Required</small>}
              </div>

              <div className='form-input mt-3'>
                <label>State</label>
                <select className='form-control' {...register('state', { required: true })}>
                  <option value=''>Select State</option>
                  {state?.map((stat, index: Key) => (
                    <option value={stat.name} key={index}>
                      {stat.name}
                    </option>
                  ))}
                </select>
                {errors.state && <small className='text-danger'>Required</small>}
              </div>

              <div className='form-input mt-3'>
                <button className='btn btn-refer' onClick={handleContinue}>
                  Continue
                </button>
              </div>
            </Fragment>
          )}

          {step === 2 && (
            <Fragment>
              <div className='form-input mt-3'>
                <label htmlFor=''>Upload Photo of wide view of entrance</label>

                <FileUpload
                  onFileChange={(event: File | null) =>
                    handleFileUpload(event, 'EXPERIENCE_CENTRE_STATION_ENTRANCE')
                  }
                ></FileUpload>
              </div>
              <div className='form-input mt-3'>
                <label htmlFor=''>Upload Photo of wide view of forecourt</label>{' '}
                <FileUpload
                  onFileChange={(event: File | null) =>
                    handleFileUpload(event, 'EXPERIENCE_CENTRE_FORECOURT')
                  }
                ></FileUpload>
              </div>
              <div className='form-input mt-3'>
                <label htmlFor=''>
                  Upload Photo of space provided for the experience centre{' '}
                  <span className='text-danger'>*</span>
                </label>{' '}
                <FileUpload
                  onFileChange={(event: File | null) =>
                    handleFileUpload(event, 'EXPERIENCE_CENTRE_SPACE_PROVIDED')
                  }
                ></FileUpload>
              </div>{' '}
              <div className='form-input mt-3'>
                <label htmlFor=''>Exit of the fuel station</label>{' '}
                <FileUpload
                  onFileChange={(event: File | null) =>
                    handleFileUpload(event, 'EXPERIENCE_CENTRE_EXIT')
                  }
                ></FileUpload>
              </div>{' '}
              <div className='form-input mt-3'>
                <label htmlFor=''>Filling station video</label>{' '}
                <FileUpload
                  onFileChange={(event: File | null) =>
                    handleFileUpload(event, 'EXPERIENCE_CENTRE_VIDEO')
                  }
                ></FileUpload>
              </div>{' '}
              <div className='form-input mt-3'>
                <div className='row'>
                  <div className='col-md-6'>
                    {' '}
                    <button className='btn btn-prev' onClick={() => setStep(1)}>
                      Previous
                    </button>
                  </div>
                  <div className='col-md-6'>
                    <button
                      className='btn btn-refer'
                      onClick={() => {
                        setStep(2)
                        submitApplication()
                      }}
                    >
                      Submit Application
                    </button>
                  </div>
                </div>
              </div>
              <div className='form-input mt-4 submit-later' onClick={() => submitApplication()}>
                I will do this later, Submit Application{' '}
              </div>
            </Fragment>
          )}
        </div>
      </Fragment>

      <ToastContainer></ToastContainer>
    </div>
  )
}

export default CreateNewExperienceCenter
